// Polyfills for smart TV browser compatibility
import 'core-js/stable';

// RequestAnimationFrame polyfill for older browsers
if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = function(callback: FrameRequestCallback) {
    return window.setTimeout(callback, 1000 / 60);
  };
}

if (!window.cancelAnimationFrame) {
  window.cancelAnimationFrame = function(id: number) {
    window.clearTimeout(id);
  };
}

// IntersectionObserver polyfill for older browsers
if (!window.IntersectionObserver) {
  (window as any).IntersectionObserver = class IntersectionObserver {
    observe() {}
    unobserve() {}
    disconnect() {}
  };
}

// CustomEvent polyfill
if (!window.CustomEvent) {
  (window as any).CustomEvent = function(type: string, params: any) {
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
}

// Promise polyfill check
if (!window.Promise) {
  console.warn('Promise not supported - consider adding a polyfill');
}

// Fetch polyfill check
if (!window.fetch) {
  console.warn('Fetch not supported - consider adding a polyfill');
}

// CSS custom properties fallback
if (!window.CSS || !window.CSS.supports || !window.CSS.supports('color', 'var(--test)')) {
  console.warn('CSS custom properties not supported');
}

// Add touch event support detection
const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
if (!hasTouch) {
  document.body.classList.add('no-touch');
}

// Add smart TV detection
const isSmartTV = /SmartTV|SMART-TV|SMART_TV|SMARTTV/i.test(navigator.userAgent) ||
                  /Web0S|Tizen|Roku|NetCast|BRAVIA/i.test(navigator.userAgent) ||
                  /AppleTV|Android TV/i.test(navigator.userAgent);

if (isSmartTV) {
  document.body.classList.add('smart-tv');
  console.log('Smart TV detected:', navigator.userAgent);
}

export { isSmartTV, hasTouch };
